import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "roleSelect", "employeeFields", "clientFields" ]

  connect() {
    this.toggleRoleFields()
  }

  toggleRoleFields() {
    const isClient = this.roleSelectTarget.value === "client"

    if (!isClient) {
      if (this.hasEmployeeFieldsTarget) {
        this.employeeFieldsTarget.classList.remove("hidden")
        this.employeeFieldsTarget.querySelectorAll("input").forEach(input => input.removeAttribute("disabled"))
      }
      if (this.hasClientFieldsTarget) {
        this.clientFieldsTarget.classList.add("hidden")
        this.clientFieldsTarget.querySelectorAll("input, textarea").forEach(input => input.setAttribute("disabled", "true"))
      }
    } else {
      if (this.hasEmployeeFieldsTarget) {
        this.employeeFieldsTarget.classList.add("hidden")
        this.employeeFieldsTarget.querySelectorAll("input").forEach(input => input.setAttribute("disabled", "true"))
      }
      if (this.hasClientFieldsTarget) {
        this.clientFieldsTarget.classList.remove("hidden")
        this.clientFieldsTarget.querySelectorAll("input, textarea").forEach(input => input.removeAttribute("disabled"))
      }
    }
  }

  toggleEmployeeFields() {
    this.toggleRoleFields()
  }
}
